export default {
  setCryptos(state, payload) {
    state.cryptos = payload;
  },
  setScene(state, payload) {
    state.scene = payload;
  },
};
